/* eslint import/prefer-default-export: 0 */

// selectors
import { getNotifications } from "Selectors/notifications";

export const dismissNotification = (notificationID) => (dispatch, getState) => {
	const state = getState();

	const currentNotifications = getNotifications(state);
	const filteredNotifications = currentNotifications.filter(
		(notification) => notification.get("key") !== notificationID
	);

	dispatch({ type: "NOTIFICATION:UPDATE", notifications: filteredNotifications });
};

export const createDesktopNotification =
	(body, timeout = 30, options = {}) =>
	() => {
		const notification = new Notification("Logan", {
			body,
			icon: "/logo.png",
		});

		if (options.onClick) {
			// on click, begin testing
			notification.onclick = () => {
				options.onClick();
			};
		}

		setTimeout(notification.close.bind(notification), timeout * 1000);
	};
